
<template>
  <v-dialog v-model="dialog" v-if="dialog" max-width="500px" transition="dialog-transition" >
    <v-card style="border-radius:12px">
      <v-card-title primary-title class="headline mb-0">
        <div class="headline mb-0">Dados NF-e</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <h3 class="pb-3">Dados da Nota Fiscal:</h3>
        <p><strong>Emitente:</strong> {{ nf_infos.company_name }}</p>
        <p><strong>Valor Total:</strong> R$ {{ nf_infos.value }}</p>
        <p><strong>CNPJ:</strong> {{ nf_infos.company_document.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') }}</p>
        <p><strong>NF:</strong> {{ nf_infos.nf_number }}</p>
        <p><strong>Link NF-e {{ nf_infos.nf }}
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mx-1" v-bind="attrs" v-on="on" @click="copyNfLink(nf_infos.attached_file_url)" :disabled="!nf_infos.attached_file_url">
              <v-icon size="20">mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copiar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mx-1" v-bind="attrs" v-on="on" @click="openNfLink(nf_infos.attached_file_url)" :disabled="!nf_infos.attached_file_url"><v-icon size="20">mdi-open-in-new</v-icon></v-btn>
          </template>
          <span>Acessar</span>
        </v-tooltip>
        </strong></p>
        
        <FileAttachment 
          :update_infos="{MODEL: 'fiscal_note', id: nf_infos.id, API: 'FiscalNote'}" 
          :attached_file_url="nf_infos.attached_file_url" 
          :is_creating="!nf_infos.id"
          ref="file_attachment" 
          direct_preview
          img_direct_preview
        ></FileAttachment>

    </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'DialogNfInfo',
  props: {
    dialog_nf_infos: {
      type: Boolean,
      default: false
    },
    nf_infos: {
      type: Object,
      required: true
    }
  },
  components:{
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    copyNfLink(url) {
      navigator.clipboard.writeText(url).then(() => {
        alert("Link copiado com sucesso!");
      }).catch(err => {
        console.error("Erro ao copiar o link: ", err);
        alert("Não foi possível copiar o link.");
      })
    },
    openNfLink(url){
      window.open(url, "_blank")
    },
  },
  watch:{
    dialog_nf_infos(nv){
      this.dialog = true
    }
  }
}
</script>
